<template>
  <el-dialog :title="modeName+'导出'" :visible.sync="dialogVisible" width="930px" append-to-body :close-on-click-modal="false" :show-close="true" @close="handleClose" v-loading="dataLoading">
    <el-form :disabled="currentDownloading || allDownloading">
      <div>
        <span>下载任务名称：</span>
        <el-input v-model="exportName" placeholder="下载任务名称" clearable style="width: 500px"></el-input>
      </div>
      <div class="sheet-list scrollbar">
        <div class="sheet-container" v-for="sheet,sheetIndex in sheetList" :key="sheetIndex">
          <div class="sheet-name">
            <span class="sheet-name-text">
              <el-checkbox :indeterminate="Boolean(sheet.isIndeterminate)" v-model="sheet.defaultExport" @change="handleCheckAllChange(sheet)">{{ 'sheet'+(sheetIndex+1) }}-{{ sheet.sheetName }}</el-checkbox>
            </span>
          </div>
          <div class="sheet-content">
            <div class="field-item" v-for="field, fieldIndex in sheet.fieldList" :key="fieldIndex">
              <el-checkbox v-model="field.defaultExport" @change="handleCheckedFieldChange(sheet, field)">{{field.fieldName}}</el-checkbox>
            </div>
          </div>
        </div>
      </div>

    </el-form>

    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button type="text" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="currentDownloading" @click="exportCurrentPage">导出当前页</el-button>
      <el-button type="primary" :loading="allDownloading" @click="exportAll">导出全部</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sheetExportApi from '@/api/common/sheetExport'
import request from '@/utils/request'
import downloadDialog from '../DownloadCenter/downloadDialog.vue'
import { parseTime } from '@/utils'
export default {
  name: 'SheetExporter',
  components: { downloadDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tagCode: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    condition: {
      type: Object,
      default: () => ({})
    },
    defaultExportName: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.dialogVisible = val
        this.getExportSheet()
      }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      exportName: '',
      modeName: '',
      sheetList: [
      ],

      dataLoading: false,
      currentDownloading: false,
      allDownloading: false,
    }
  },
  methods: {
    // 获取表列
    getExportSheet() {
      this.dataLoading = true;
      sheetExportApi.getExportSheet(this.tagCode).then(res => {
        this.modeName = res.modeName
        this.exportName = this.defaultExportName || (this.modeName + '-' + parseTime(Date.now(), "{y}{m}{d}{h}{i}{s}"))
        this.sheetList = res.sheetList
        this.sheetList.forEach(sheet => {
          sheet.fieldList.forEach(field => {
            this.handleCheckedFieldChange(sheet)
          })
        })
      }).finally(() => {
        this.dataLoading = false;
      })
    },
    // 全选
    handleCheckAllChange(sheet) {
      sheet.fieldList.forEach(item => item.defaultExport = sheet.defaultExport)
      sheet.isIndeterminate = false;
    },
    // 单个勾选
    handleCheckedFieldChange(sheet, field) {
      let checkedCount = 0;
      sheet.fieldList.forEach(item => item.defaultExport && ++checkedCount);
      sheet.isIndeterminate = checkedCount > 0 && checkedCount < sheet.fieldList.length;
      sheet.defaultExport = checkedCount === sheet.fieldList.length;
    },
    validate() {
      if (!this.exportName) {
        this.$notify({
          title: '请输入任务名称',
          type: 'warning'
        })
        return false
      }
      else if (!this.sheetList.find(sheet => sheet.defaultExport || sheet.fieldList.find(field => field.defaultExport))) {
        this.$notify({
          title: '请选择导出报表',
          type: 'warning'
        })
        return false
      }
      else {
        // 表头带汇总需合并表头的报表
        const headSheet = this.sheetList.find(sheet => sheet.head)
        if (headSheet && headSheet.fieldList.filter(field => field.defaultExport).length < 2) {
          this.$notify({
            title: `导出报表【${headSheet.sheetName}】需选择两个或以上字段`,
            type: 'warning'
          })
          return false
        }
      }
      return true
    },
    // 导出当前页
    exportCurrentPage() {
      if (!this.validate()) return
      this.currentDownloading = true
      this.exportData('C_PAGE').finally(() => this.currentDownloading = false)
    },
    // 导出全部
    exportAll() {
      if (!this.validate()) return
      this.allDownloading = true
      this.exportData('ALL_PAGE').finally(() => this.allDownloading = false)
    },
    // 导出数据
    exportData(pageMode) {
      const exportData = {
        exportName: this.exportName,
        modeName: this.modeName,
        format: this.format,
        pageMode,
        sheetList: this.sheetList.map(sheet => {
          return {
            exportFields: sheet.fieldList.filter(item => item.defaultExport).map(item => item.fieldKey),
            sheetCode: sheet.sheetCode
          }
        }).filter(sheet => Boolean(sheet.exportFields.length)),
        tagCode: this.tagCode
      }
      let condition = {}
      Object.keys(this.condition|| {}).forEach(key => {
        if (this.condition[key]) {
          condition[key] = this.condition[key].toString()
        }
      })
      const params = { ...condition, export: encodeURIComponent(JSON.stringify(exportData)) }
      return request({
        url: this.url,
        method: 'get',
        params
      }).then(() => {
        this.$message.success('已创建导出任务')
        this.dialogVisible = false
        this.$bus.$emit("createAsyncTask");
      })
    },
    handleClose() {
      this.exportName = ''
      this.modeName = ''
      this.queryLoading = false
      this.currentDownloading = false
      this.allDownloading = false
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-list {
  max-height: 60vh;
  padding: 10px;
}
.sheet-container {
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.2));
  .sheet-name {
    position: relative;

    &::before {
      content: '';
      display: block;
      height: 50px;
      width:250px;
      border: 0 solid transparent;
      border-bottom: 30px solid #fff;
      border-right: 50px solid transparent;
    }
    .sheet-name-text {
      position: absolute;
      top: 60%;
      padding-left: 15px;
    }
  }
  .sheet-content {
    background-color: #fff;
    padding: 20px 15px;
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    .field-item {
      width: 200px;
    }
    .el-checkbox {
      margin-bottom: 10px;
    }
  }
}

.scrollbar {
  overflow-y: scroll;
  /* 修改垂直滚动条 */
  &::-webkit-scrollbar {
    width: 4px; /* 修改宽度 */
  }

  /* 修改滚动条轨道背景色 */
  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  /* 修改滚动条滑块颜色 */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(197, 194, 194, 0.5)
  }

  /* 修改滚动条滑块悬停时的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
}
</style>
